export class CardModel {
  constructor(data: any, id?: string) {
    let cards = ['american_express', 'discover', 'mastercard', 'visa'];
    this.id = data.id || id;
    this.brand = data.brand;
    this.brand_short = data.brand.replace(' ', '_').toLowerCase();
    this.last4 = data.last4;
    this.exp_month = data.exp_month.toString();
    this.exp_year = data.exp_year.toString();
    if (cards.indexOf(this.brand_short) == -1) this.brand_short = 'unknown';
  }

  id: string;
  brand: string;
  brand_short: string;
  last4: string;
  exp_month: string;
  exp_year: string;

  getExpiration() {
    let month = parseInt(this.exp_month) > 10 ? this.exp_month : '0' + this.exp_month;
    let year = this.exp_year.substr(2);
    return month + '/' + year;
  }
}
